export function environmentBucket (useCdn = false) {
    if (useCdn) {
        return process.env.VUE_APP_CDN_HOST;
    }

    return process.env.VUE_APP_STATIC_HOST;
}

export function getContentHost (app) {
    if (app && app.applicationFlags.cname && app.contentCname) {
        return app.contentCname;
    }

    return environmentBucket(true);
}

export function getDataHost (app) {
    if (app && app.applicationFlags.cname && app.dataCname) {
        return app.dataCname;
    }

    return process.env.VUE_APP_APP_DOMAIN;
}

export function getAltDataHost (app) {
    if (app && app.applicationFlags.cname && app.dataCname && app.contentCname) {
        return;
    }

    return process.env.VUE_APP_DATA_HOST;
}

export function getStaticHost (subscription, app) {
    if (app && app.applicationFlags.enableContentProxy) {
        return `content-${subscription.id}.${process.env.VUE_APP_DOMAIN_TEMPLATE.replace('%s', 'static')}`;
    }

    if (app && app.applicationFlags.cname && app.contentCname) {
        return app.contentCname;
    }

    return process.env.VUE_APP_SUB_STATIC_HOST_TEMPLATE.replace('%s', subscription.id);
}

export function getCDNHost () {
    return process.env.VUE_APP_CDN_HOST;
}

export function getAppHost () {
    return process.env.VUE_APP_APP_DOMAIN;
}

export function getPortalHost () {
    return process.env.VUE_APP_PORTAL_DOMAIN;
}

export function getWatcherBucket () {
    const envType = isProdEnvironment() ? 'prod' : 'dev';

    return `https://storage.cloud.google.com/pendo-infra-${envType}-monitoring/${process.env.VUE_APP_ENV_NAME}.html`;
}

export function isScrumEnvironment (env = window.appEnvId) {
    if (isProdEnvironment()) return false;

    const excludedEnvs = ['test', 'local'];

    return env && !excludedEnvs.includes(env);
}

export function isProdEnvironment () {
    return process.env.VUE_APP_ENV_IS_PROD === 'true';
}
